import { GreenCheckIcon } from 'assets/icons/CheckCheckIcon'
import { WarningCircle } from 'assets/icons/WarningCircle'
import { DCLineItem } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'

interface ILineItem {
    title: string
    count: number
    warning?: boolean
    noBottom?: boolean
    borderTop?: boolean
    numberOnly?: boolean
}
export const LineItem = ({ title, count, warning, noBottom, borderTop, numberOnly }: ILineItem) => {
    return <DCLineItem noBottom={noBottom} warning={warning} borderTop={borderTop}>
        <OtherText>{title}</OtherText>
        <div>
            <OtherText weight='bold' style={numberOnly && { color: '#FF5B5B' }}>{count}</OtherText>
            {!numberOnly && (!warning ? GreenCheckIcon : WarningCircle)}
        </div>
    </DCLineItem>
}